<template>
    <div class="form-container">
        <el-form v-loading="loading" ref="postForm" :validate-on-rule-change="false" v-if="postForm" :model="postForm" :rules="rules" class="form-container" :label-position="labelPosition" label-width="505px">
            <sticky :class-name="'sub-navbar draft'">
                <el-button v-loading="loading" size="small" @click="save()" type="success">Enviar</el-button>
            </sticky>

            <h2>Termos e Contratos</h2>
            <p>Faça o download dos documentos abaixo, assine e em seguida anexe nos campos respectivos:</p>

            <el-button-group>
                <a class="el-button el-button--default" href="javascript:void(0)" @click="downloadContrato()">Contrato de Trabalho</a>
                <!--<a class="el-button el-button--default" target="_blank" href="/modelos/Brunel_Termo_de_Responsabilidade_Esocial.pdf">Termo de Responsabilidade E-Social</a>-->
                <a v-if="displayNoShow" class="el-button el-button--default" target="_blank" href="/modelos/Termo_de_Ciencia_e_Responsabilidade_No_Show.docx">Termo de Responsabilidade "No Show"</a>
                <!--<a class="el-button el-button--default" target="_blank" href="/modelos/Carta_Abertura_de_Conta.docx">Carta do Banco</a>-->
            </el-button-group>

            <br>
            <br>

            <el-form-item label="Anexe aqui seu contrato de trabalho assinado em PDF" prop="anexo_contrato_assinado" class="postInfo-container-item is-required">
                <el-upload-x action="" accept="application/pdf" :auto-upload="false" class="flex" :multiple="false" :limit="1" ref="anexo_contrato_assinado" prop="anexo_contrato_assinado">
                    <el-tooltip class="item" effect="dark" content="Anexar Documento" placement="top-start">
                        <el-button type="primary">Importar</el-button>
                    </el-tooltip>
                </el-upload-x>
                <upload-error prop="anexo_contrato_assinado" :errors="invalidUploads"/>
            </el-form-item>

            <!--<el-form-item label="Anexe aqui termo de responsabilidade e-social assinado" prop="anexo_esocial_assinado" class="postInfo-container-item is-required">
                <el-upload-x action="" accept="application/pdf" :auto-upload="false" class="flex" :multiple="false" :limit="1" ref="anexo_esocial_assinado" prop="anexo_esocial_assinado">
                    <el-tooltip class="item" effect="dark" content="Anexar Documento" placement="top-start">
                        <el-button type="primary">Importar</el-button>
                    </el-tooltip>
                </el-upload-x>
                <upload-error prop="anexo_esocial_assinado" :errors="invalidUploads"/>
            </el-form-item>-->

            <el-form-item v-if="displayNoShow" label="Anexe aqui termo de responsabilidade 'No Show'" prop="anexo_termo_responsabilidade_no_show" class="postInfo-container-item is-required">
                <el-upload-x action="" accept="application/pdf" :auto-upload="false" class="flex" :multiple="false" :limit="1" ref="anexo_termo_responsabilidade_no_show" prop="anexo_termo_responsabilidade_no_show">
                    <el-tooltip class="item" effect="dark" content="Anexar Documento" placement="top-start">
                        <el-button type="primary">Importar</el-button>
                    </el-tooltip>
                </el-upload-x>
                <upload-error prop="anexo_termo_responsabilidade_no_show" :errors="invalidUploads"/>
            </el-form-item>

            <!--<el-form-item label="Anexe aqui a carta do banco" prop="anexo_carta_banco" class="postInfo-container-item is-required">
                <el-upload-x action="" accept="application/pdf" :auto-upload="false" class="flex" :multiple="false" :limit="1" ref="anexo_carta_banco" prop="anexo_carta_banco">
                    <el-tooltip class="item" effect="dark" content="Anexar Documento" placement="top-start">
                        <el-button type="primary">Importar</el-button>
                    </el-tooltip>
                </el-upload-x>
                <upload-error prop="anexo_carta_banco" :errors="invalidUploads"/>
            </el-form-item>-->

            <p><b>OBS: <u>CARTEIRA DE TRABALHO</u> - </b> O RH ENTRARÁ EM CONTATO PARA ASSINATURA EM <b>48 HORAS</b> ANTES DA ADMISSÃO.</p>
        </el-form>
    </div>
</template>


<script>
import request from '@/request'
import Sticky from '@/components/Sticky'
import ElUploadX from '@/components/Upload/src'
import UploadError from '@/components/UploadError'

export default {
    name: 'ContratoForm',
    components: { Sticky, UploadError, ElUploadX },
    data() {
        return {
            loading: false,
            labelPosition: 'left',
            postForm: {},
            admissao: null,
            invalidUploads: [],
            rules: {}
        }
    },
    created() {
        this.fetchData();
    },
    computed: {
        displayNoShow() {
            return this.admissao && this.admissao.empresa.nome.startsWith('HRT') && this.admissao.contrato.tipo.endsWith('Offshore')
        }
    },
    methods: {
        fetchData() {
            request({
                url: `funcionario/${this.$route.params.uid}/contrato`,
                method: 'get',
            }).then(response => {
                this.loading = false
                this.admissao = response.data
            }, error => {
                this.loading = false
                if ( error.response.status === 404) {
                    this.$router.push('/contrato/invalido')
                } else {
                    this.$message({
                        showClose: true,
                        message: `Falha ao recuperar dados do formulário ${error.bodyText}`,
                        type: 'error'
                    })
                }
            })
        },
        save() {
            const data = this.prepareData()
            this.$refs['postForm'].validate(valid => {
                if (valid && this.invalidUploads.length == 0) {
                    this.loading = true
                    request({
                        url: `funcionario/${this.$route.params.uid}/contrato`,
                        method: 'POST',
                        data: data,
                        headers: {
                        'Content-Type': 'multipart/form-data'
                        }
                    }).then(() => {
                        this.loading = false
                        this.$router.push('/contrato/finalizado')
                    }, error => {
                        this.loading = false
                        this.$message({
                            showClose: true,
                            message: `Falha ao salvar formulário: ${error.response.data.description}`,
                            type: 'error'
                        })

                        if (error.response.data.fields) {
                            error.response.data.fields.forEach(postFile => {
                                this.invalidUploads.push({key: postFile.key, message: 'Formato ' + postFile.mimetype + ' inválido'})
                            })
                        }
                    })
                } else {
                    this.loading = false
                }
            })
        },
        prepareData() {

            this.invalidUploads = []
            const formData = new FormData()
            const anexos = Object.keys(this.$refs).filter(item => {
                return item.startsWith('anexo')
            })

            anexos.forEach(postFile => {
                let upload = this.$refs[postFile];
                if (Array.isArray(this.$refs[postFile])) {
                    upload = this.$refs[postFile][0]
                }
                //upload.disabled
                if (upload.uploadFiles[0]) {
                    if (upload.uploadFiles[0].raw) {
                        formData.append(postFile, upload.uploadFiles[0].raw)
                    }
                } else {
                    if (!upload.disabled) {
                        this.invalidUploads.push({key: postFile, message: 'Upload obrigatório'})
                    }
                }
            }, this)

            return formData
        },
        downloadContrato() {
            window.open(`${request.defaults.baseURL}/funcionario/${this.$route.params.uid}/contrato/download?ts=${Date.now()}`)
        }
    }
}
</script>

<style>
.sub-navbar {
  height: 50px;
  line-height: 50px;
  position: relative;
  width: 100%;
  text-align: right;
  padding-right: 20px;
  transition: 600ms ease position;
  background: #F2F6FC;
}
</style>
